import { useParams, useSearchParams } from 'react-router-dom';

export const useId = (): string | undefined => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  if (typeof id !== 'undefined') {
    return id;
  } else if (searchParams.has('id')) {
    return searchParams.get('id') || undefined;
  }

  return undefined;
};
